export interface FontFamilyProps {
  id: string;
  name: string;
  cssValue: string;
}

export const FontFamilies: FontFamilyProps[] = [
  {
    id: 'arial',
    name: 'Arial',
    cssValue: 'Arial, Helvetica, sans-serif',
  },
  {
    id: 'bookman',
    name: 'Bookman Old Style',
    cssValue: "'Bookman Old Style', Bookman, 'Utopia', 'URW Bookman L', 'Palatino Linotype', serif",
  },
  {
    id: 'calibri',
    name: 'Calibri',
    cssValue: "Calibri, Candara, Segoe, 'Segoe UI', Optima, Arial, sans-serif",
  },
  {
    id: 'centuryGothic',
    name: 'Century Gothic',
    cssValue: "'Century Gothic', CenturyGothic, AppleGothic, sans-serif",
  },
  {
    id: 'comic',
    name: 'Comic Sans',
    cssValue: "'Comic Sans MS', 'Comic Sans', cursive, sans-serif",
  },
  {
    id: 'courier',
    name: 'Courier New',
    cssValue: "'Courier New', Courier, monospace",
  },
  {
    id: 'firaCode',
    name: 'Fira Code',
    cssValue: "'Fira Code', monospace",
  },
  {
    id: 'garamond',
    name: 'Garamond',
    cssValue:
      "Garamond, Baskerville, 'Baskerville Old Face', 'Hoefler Text', 'Times New Roman', serif",
  },
  {
    id: 'geneva',
    name: 'Geneva',
    cssValue: 'Geneva, Tahoma, sans-serif',
  },
  {
    id: 'georgia',
    name: 'Georgia',
    cssValue: 'Georgia, serif',
  },
  {
    id: 'impact',
    name: 'Impact',
    cssValue:
      "Impact, Haettenschweiler, 'Franklin Gothic Bold', Charcoal, 'Helvetica Inserat', 'Bitstream Vera Sans Bold', 'Arial Black', sans-serif",
  },
  {
    id: 'inter',
    name: 'Inter',
    cssValue: "'Inter', sans-serif",
  },
  {
    id: 'lucidaGrande',
    name: 'Lucida Grande',
    cssValue: "'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Geneva, Verdana, sans-serif",
  },
  {
    id: 'palatino',
    name: 'Palatino',
    cssValue: "Palatino, 'Palatino Linotype', 'Palatino LT STD', 'Book Antiqua', Georgia, serif",
  },
  {
    id: 'playfair',
    name: 'Playfair Display',
    cssValue: "'Playfair Display', serif",
  },
  {
    id: 'poppins',
    name: 'Poppins',
    cssValue: "'Poppins', sans-serif",
  },
  {
    id: 'roboto',
    name: 'Roboto',
    cssValue: "'Roboto', sans-serif",
  },
  {
    id: 'tahoma',
    name: 'Tahoma',
    cssValue: 'Tahoma, Geneva, sans-serif',
  },
  {
    id: 'timesNewRoman',
    name: 'Times New Roman',
    cssValue: "'Times New Roman', Times, serif",
  },
  {
    id: 'trebuchet',
    name: 'Trebuchet MS',
    cssValue:
      "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
  },
  {
    id: 'verdana',
    name: 'Verdana',
    cssValue: 'Verdana, Geneva, sans-serif',
  },
];
